<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    titleKey="name"
  />
</template>

<script>
import model from '@/models/announcement';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      pageSetting: {
        primary: [
          {
            type: 'infoCard',
            floors: [
              {
                fields: [
                  'locales',
                  'author',
                  'authorizer',
                  'cover_image',
                  'attaches',
                ],
              },
            ],
          },
        ],
        secondary: [
          {
            type: 'infoCard',
            floors: [
              {
                title: '設定',
                fields: [
                  'alliance',
                ],
              },
            ],
          },
          {
            type: 'activeSwitch',
            title: '顯示設定',
            remark: '隱藏的內容將不會顯示於使用者前台介面',
            field: 'is_active',
          },
        ],
      },
    };
  },
};
</script>